import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaSearch } from 'react-icons/fa';
import { formatBlogDate } from '../../../utils/blogDate';

const BlogPage = () => {
  const [blogs, setBlogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const articlesPerPage = 6;

  const fetchData = async (page = 1, search = "") => {
    setLoading(true);
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}admin-mat/api/blog.php`);

      if (res.data && Array.isArray(res.data)) {
        const needle = search.toLowerCase();
        const filteredBlogs = search
          ? res.data.filter(blog =>
              (blog.blog_name || '').toLowerCase().includes(needle) ||
              (blog.blog_keyword || '').toLowerCase().includes(needle))
          : res.data;

        setBlogs(filteredBlogs);
        setTotalPages(Math.ceil(filteredBlogs.length / articlesPerPage));
      } else {
        console.error('Invalid response format:', res.data);
      }
    } catch (error) {
      console.error('Error fetching blogs:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(currentPage, searchTerm);
  }, [currentPage, searchTerm]);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    fetchData(1, searchTerm);
  };

  const featuredBlogs = blogs.slice(0, 4);
  const startIndex = (currentPage - 1) * articlesPerPage;
  const paginatedArticles = blogs.slice(startIndex, startIndex + articlesPerPage);

  return (
    <div className="container blog-page py-5">
      <style>{`
        .blog-badge {
          display: inline-block;
          background-color: #fce4ec;
          color: #333;
          font-size: 14px;
          padding: 5px 12px;
          border-radius: 4px;
        }
        .blog-title {
          font-size: 2rem;
          margin-top: 10px;
        }
        .blog-title .highlight {
          color: #e53d5c;
        }
        .blog-subtitle {
          color: #555;
          font-size: 1rem;
        }
        .search-wrapper {
          display: flex;
          max-width: 500px;
          margin: 0 auto;
          border: 1px solid #ccc;
          border-radius: 22px;
          overflow: hidden;
        }
        .search-input {
          border: none;
          padding: 10px 15px;
          flex-grow: 1;
          font-size: 16px;
        }
        .search-btn {
          background-color: #e53d5c;
          border: none;
          color: white;
          padding: 10px 18px;
          font-size: 18px;
        }
        .trending-topics {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
          gap: 10px;
        }
        .trending-label {
          font-weight: 500;
          color: #333;
        }
        .topic-pills {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 8px;
        }
        .topic-pill {
          border: 1px solid #e4e4e4;
          background-color: #f6f6f6;
          color: #333;
          border-radius: 999px;
          padding: 6px 16px;
          font-size: 0.9rem;
          line-height: 1.4;
          white-space: nowrap;
          transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;
        }
        .topic-pill:hover {
          background-color: #fdeef1;
          border-color: #f3c9d2;
          color: #e53d5c;
        }
        .topic-pill.active {
          background-color: #e53d5c;
          border-color: #e53d5c;
          color: #fff;
        }
        .section-heading {
          font-size: 1.5rem;
          font-weight: 600;
          margin-bottom: 20px;
        }
        .featured-card {
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          height: 260px;
          padding: 18px;
          border-radius: 15px;
          overflow: hidden;
          background-color: #f1e7ea;
          background-size: cover;
          background-position: center;
          color: #fff;
          text-decoration: none;
          transition: transform 0.3s, box-shadow 0.3s;
        }
        /* Bootstrap's a:hover outranks the class rule above, so restate the colour. */
        .featured-card:hover {
          color: #fff;
          transform: translateY(-5px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.18);
        }
        /* Titles sit over arbitrary uploads, so they need their own backdrop. */
        .featured-card::before {
          content: "";
          position: absolute;
          inset: 0;
          background: linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.45) 45%, rgba(0,0,0,0.05) 100%);
        }
        .featured-card .overlay {
          position: relative;
          z-index: 1;
        }
        .featured-card .tag {
          background-color: rgba(255, 255, 255, 0.92);
          color: #e53d5c;
          padding: 3px 12px;
          font-size: 12px;
          font-weight: 600;
          border-radius: 15px;
          display: inline-block;
          margin-bottom: 8px;
        }
        /* style.css colours h5, span and a directly, and a rule that matches the
           element always beats a colour inherited from the card, so restate it. */
        .featured-card .featured-title {
          color: #fff;
          font-size: 1.05rem;
          font-weight: 600;
          line-height: 1.35;
          margin: 0;
          text-shadow: 0 1px 3px rgba(0, 0, 0, 0.6);
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        .featured-card .featured-more {
          color: #fff;
          display: inline-block;
          margin-top: 10px;
          font-size: 0.8rem;
          font-weight: 600;
          text-shadow: 0 1px 3px rgba(0, 0, 0, 0.6);
          border-bottom: 1px solid rgba(255, 255, 255, 0.6);
        }
        .article-card {
          border: 1px solid #eee;
          border-radius: 10px;
          transition: 0.3s;
          height: 100%;
          margin-bottom: 20px;
        }
        .article-card:hover {
          box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
          transform: translateY(-5px);
        }
        .article-card img {
          height: 200px;
          object-fit: cover;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          width: 100%;
        }
        .card-body {
          padding: 15px;
          display: flex;
          flex-direction: column;
        }
        .card-title {
          font-size: 1.1rem;
          margin-bottom: 10px;
        }
        .card-text {
          flex-grow: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          color: #555;
          font-size: 0.9rem;
          margin-bottom: 15px;
        }
        .no-blogs {
          text-align: center;
          padding: 40px;
          color: #666;
        }
        .read-more-btn {
          margin-top: auto;
          align-self: flex-start;
          font-size: 0.8rem;
          padding: 5px 10px;
        }
        .pagination {
          justify-content: center;
          flex-wrap: wrap;
          margin-top: 30px;
        }
        .page-item.active .page-link {
          background-color: #e53d5c;
          border-color: #e53d5c;
        }
        .page-link {
          color: #e53d5c;
        }

        @media (max-width: 767.98px) {
          .blog-page {
            padding-top: 24px !important;
            padding-bottom: 24px !important;
          }
          .blog-title {
            font-size: 1.5rem;
          }
          .blog-subtitle {
            font-size: 0.9rem;
          }
          /* The hand-placed line break lands mid-sentence on narrow screens. */
          .blog-subtitle br {
            display: none;
          }
          .search-input {
            font-size: 14px;
            padding: 9px 12px;
          }
          .trending-topics {
            gap: 8px;
          }
          /* Full width so the label keeps its own line above the pills. */
          .trending-label {
            width: 100%;
            font-size: 0.9rem;
          }
          .topic-pill {
            padding: 5px 13px;
            font-size: 0.82rem;
          }
          .section-heading {
            font-size: 1.2rem;
          }
          .featured-card {
            height: 170px;
            padding: 12px;
          }
          .featured-card .tag {
            font-size: 11px;
            padding: 2px 9px;
            margin-bottom: 6px;
          }
          .featured-card .featured-title {
            font-size: 0.85rem;
          }
          .featured-card .featured-more {
            margin-top: 6px;
            font-size: 0.72rem;
          }
          .article-card img {
            height: 180px;
          }
          .page-link {
            padding: 5px 10px;
            font-size: 0.85rem;
          }
        }
      `}</style>

      <div className="text-center">
        <div className="blog-badge">Blog</div>
        <h3 className="blog-title">
          Discover Our Latest <span className="highlight">Articles</span>
        </h3>
        <p className="blog-subtitle">
          Advice on matchmaking, staying safe online and building a happy <br />
          married life, from the Hindu Sanjog team.
        </p>

        <form className="search-bar mx-auto my-4" onSubmit={handleSearchSubmit}>
          <div className="search-wrapper">
            <input
              type="text"
              placeholder="What are you looking for?"
              className="search-input"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <button type="submit" className="search-btn">
              <FaSearch />
            </button>
          </div>
        </form>

        <div className="trending-topics mb-5">
          <span className="trending-label">Trending Topics:</span>
          <div className="topic-pills">
            {['All', 'Wedding', 'Matrimonial', 'Relationship'].map((topic, i) => (
              <button
                key={i}
                type="button"
                className={`topic-pill ${searchTerm === topic || (topic === 'All' && !searchTerm) ? 'active' : ''}`}
                onClick={() => {
                  setSearchTerm(topic === 'All' ? '' : topic);
                  setCurrentPage(1);
                }}
              >
                {topic}
              </button>
            ))}
          </div>
        </div>
      </div>

      {featuredBlogs.length > 0 && (
        <>
          <h4 className="section-heading">Featured</h4>
          <div className="row mb-5">
            {featuredBlogs.map((item) => (
              <div className="col-6 col-md-3 mb-4" key={item.blog_id}>
                <Link
                  to={`/blog/${item.blog_id}`}
                  className="featured-card"
                  style={{
                    backgroundImage: `url(${process.env.REACT_APP_API_BASE_URL}${item.blog_img})`
                  }}
                >
                  <div className="overlay">
                    <span className="tag">{(item.blog_keyword || '').split(',')[0]?.trim() || 'Blog'}</span>
                    <h5 className="featured-title">{item.blog_name}</h5>
                    <span className="featured-more">Read More</span>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </>
      )}

      <h4 className="section-heading">
        Recent <span className="highlight">Articles</span>
      </h4>
      <div className="row">
        {loading ? (
          <div className="text-center w-100 py-5">Loading...</div>
        ) : paginatedArticles.length > 0 ? (
          paginatedArticles.map((article) => (
            <div className="col-md-4 col-sm-6" key={article.blog_id}>
              <div className="article-card">
                <img 
                  src={`${process.env.REACT_APP_API_BASE_URL}${article.blog_img}`}
                  alt={article.blog_name}
                  className="card-img-top"
                />
                <div className="card-body">
                  <h5 className="card-title">{article.blog_name}</h5>
                  <small className="text-muted mb-2">
                    {formatBlogDate(article.updated_on || article.created_at)}
                  </small>
                  <p className="card-text">
                    {(article.blog_desc || '').replace(/<[^>]*>/g, '').substring(0, 150)}...
                  </p>
                  <Link 
                    to={`/blog/${article.blog_id}`}
                    className="btn btn-outline-danger read-more-btn"
                  >
                    Read More
                  </Link>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="no-blogs w-100">
            <h5>No articles found</h5>
            <p>Try a different search term or check back later</p>
          </div>
        )}
      </div>

      {totalPages > 1 && (
        <nav>
          <ul className="pagination">
            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
              <button className="page-link" onClick={() => setCurrentPage(1)}>
                &laquo;
              </button>
            </li>
            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
              <button className="page-link" onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}>
                &lsaquo;
              </button>
            </li>
            {[...Array(totalPages)].map((_, i) => (
              <li key={i + 1} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(i + 1)}>
                  {i + 1}
                </button>
              </li>
            ))}
            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
              <button className="page-link" onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}>
                &rsaquo;
              </button>
            </li>
            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
              <button className="page-link" onClick={() => setCurrentPage(totalPages)}>
                &raquo;
              </button>
            </li>
          </ul>
        </nav>
      )}
    </div>
  );
};

export default BlogPage;